module.exports = __webpack_public_path__ + "assets/img/play__icon.c6f3ef99.svg";